import { Pipe, PipeTransform } from '@angular/core';
import { NormalizerHelper } from 'src/app/core/helpers/normalizer.helper';

@Pipe({
  name: 'padStart',
})
export class PadStartPipe implements PipeTransform {
  transform(value: any, targetLength: number, padString: string = '0'): string {
    return NormalizerHelper.padStart(value, targetLength, padString);
  }
}
